export const getToken = () => {
    let dataToken = document.cookie.split(';');
    let nameToken = 'token=';
    let token = '';
    for(var i = 0; i <dataToken.length; i++) {
        if(dataToken[i].includes(nameToken) == true){
            token = dataToken[i];
        }
    }
    if(token != ''){
        token = token.split('=')[1];
        return token;
    }else{
        return '';
    }
}

export const destroyCookie = () => {
    let token = 'Unauthorized';
    let hostname = window.location.hostname;
    let base = '';
    if(hostname != 'localhost'){
        base = '.' + hostname;
        base = base.replace('.touch', '');
        base = base.replace('touch', '');
    }
    document.cookie = 'token=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + base;
    document.cookie = 'login_name=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + base;
    document.cookie = 'PHPSESSO=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + base;
    document.cookie = 'PHPSESSD=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + base;

    document.cookie = 'token=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + hostname;
    document.cookie = 'login_name=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + hostname;
    document.cookie = 'PHPSESSO=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + hostname;
    document.cookie = 'PHPSESSD=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + hostname;

    document.cookie = 'token=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=';
    document.cookie = 'login_name=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=';
    document.cookie = 'PHPSESSO=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=';
    document.cookie = 'PHPSESSD=' + token +'; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=';
}

export const updateToken = (token, date) => {
    let exp_at = new Date(date * 1000);
    let domain = window.location.hostname;
    let base = '';
    if(domain != 'localhost'){
        base = '.' + domain;
        base = base.replace('.touch', '');
        base = base.replace('touch', '');
    }
    document.cookie = 'token=Unauthorized; expires=Thu, 01 Jan 1970 00:00:00 UTC"; path=/; domain=' + base;
    document.cookie = 'token=' + token + '; expires=' + exp_at + '; path=/; domain=' + base;
    axios.defaults.headers.common['Authorization'] = token;
}
